import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Dispatch, SetStateAction, useState } from 'react'
import { Card, CardContent, CardMedia, useMediaQuery } from '@mui/material';

import { IProducto } from '../../../Interfaces/IProductos';

import '../styles/swipperInicio.css'
import stylesModule from '../styles/stylesInicio.module.css';

interface Props {
  productos: IProducto[];
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
  setIsCompras: Dispatch<SetStateAction<boolean>>; 
  setProduct: Dispatch<SetStateAction<IProducto>>;
}

const SwiperProductos = ({ productos, setDialogOpen, setIsCompras, setProduct } : Props) => {

  const [swiperInstance, setSwiperInstance] = useState<any>(null);
  const isMobile = useMediaQuery('(max-width: 650px)');

  const matches2 = useMediaQuery('(max-width: 1025px)');
  const matches3 = useMediaQuery('(max-width: 1250px)');
  // console.log(productos);
  return (
    <div className={stylesModule.containerArrows}>
      <Swiper
        slidesPerView={isMobile ? 1 : matches2 ? 2 : matches3 ? 3 : 4}
        spaceBetween={20}
        navigation
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: true,
        }}
        pagination={{
          clickable: true,
          ...(isMobile && {
            dynamicBullets: true,
            bulletActiveClass: 'bullet-active-inicio',
            bulletClass: 'bullet-inicio'
          })
        }}
        className="mySwiper"
        onSwiper={(swiper) => setSwiperInstance(swiper)}
      >
        {productos &&
          productos.length > 0 &&
          productos.map(
            (material: IProducto, index: number) => (
              <SwiperSlide
                style={{
                  marginBottom: '2rem',
                }}
                key={String(material.tipoPagoID)}
                id={String(material.tipoPagoID)}
                className='swipper-slide-custom'
                data-tipo-pago-id={material.tipoPagoID}
              >
                <Card
                  className="px-2"
                  style={{ boxShadow: 'none' }}
                  sx={{ margin: '2rem 0 1rem 0' }}
                  onClick={() => {
                    setDialogOpen(true);
                    if (setIsCompras) {
                      setIsCompras(true);
                    }
                    setProduct(material);
                  }}
                >
                  <div
                    onDragStart={(e) => e.preventDefault()}
                    className="max-w-[300px] m-auto"
                  >
                    <CardMedia
                      className={stylesModule.media}
                      component="img"
                      src={material.portada}
                      alt={material.titulo || 'Producto'}
                      style={{
                        boxShadow: '0px 15px 15px -5px grey',
                        height: '200px',
                        borderRadius: '15px',
                        cursor: 'pointer',
                        maxWidth: '300px',
                        margin: 'auto',
                      }}
                    />
                    <CardContent>
                      <div>
                        <p className="m-0 text-[#E8A817] font-bold text-sm">
                          {material.subTipo}
                        </p>
                      </div>
                      <div className={`hind`} style={{ height: '76px' }}>
                        <p className="m-0 flex items-center mb-1 font-bold text-lg">
                          {material.titulo} <br />
                          {/* {material.subtitle && material.subtitle} */}
                        </p>
                        {/* <p
                          className="m-0 mb-2 font-bold text-lg"
                          style={{ color: '#04A41E' }}
                        >
                          $ {material.precio} dólares
                        </p> */}
                      </div>
                    </CardContent>
                  </div>
                </Card>
              </SwiperSlide>
            ),
          )}
      </Swiper>
      {/* Flechas de navegación */}
    </div>
  )
}

export default SwiperProductos;